import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';
import { IMenuFilter, MenuState } from '@nimbus-library/features/menu';

export class NavigationFilter implements IMenuFilter {
  private readonly hideMenuQueryParamId = 'hide-menu';

  public constructor(private readonly store: Store) {}

  public validate$(): Observable<boolean> {
    return combineLatest([
      this.store.select(MenuState.route).pipe(skipWhile((route) => !route)),
      this.store.select(MenuState.urlAfterRedirect).pipe(skipWhile((urlAfterRedirect) => !urlAfterRedirect)),
    ]).pipe(
      map(([activatedRoute, urlAfterRedirects]) => {
        const routeData = this.retrieveRouteDataField<boolean>('hideMenu', activatedRoute.root);
        const hideMenu = urlAfterRedirects.queryParams[this.hideMenuQueryParamId] || routeData;

        return !hideMenu;
      }),
    );
  }

  public retrieveRouteDataField<T>(fieldname: string, route: ActivatedRouteSnapshot): T {
    let data = route.data[fieldname];

    if (data === undefined && route.firstChild) {
      data = this.retrieveRouteDataField(fieldname, route.firstChild);
    }
    return data as T;
  }
}
